import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './components/Home/Home';
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import NoPage from './components/NoPage/NoPage';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationNO from "./locales/no-translation.json";
import translationENG from "./locales/eng-translation.json";

const resources = {
  no: {
    translation: translationNO,
  },
  eng: {
    translation: translationENG,
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: "no",
  fallbackLng: "no",
  interpolation: {
    escapeValue: false,
  },
});

function App() {

  function handleTabChange(tabName: string) {
    console.log(`Tab changed to: ${tabName}`);
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Header tabChanged={handleTabChange} />
        <Routes>
          <Route path="/">
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
            <Route path="*" element={<NoPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Footer />
    </div>
  );
}

export default App;
